import React from "react";

import { Image } from "semantic-ui-react";

import CheckInLayout from "./CheckInLayout";

import "./AppTodayAppointment.css";

// ======================= Constants =======================
const IMAGES = {
  iconPackage: "/static/images/checkin/icon-package.png",
  iconPhoneHeart: "/static/images/checkin/icon-phone-heart.png",
};

// ======================= Component =======================
const NoAppNoPKFound = () => (
  <CheckInLayout>
    <div className="appointment-content">
      <Image src={IMAGES.iconPackage} style={{ width: "7rem", height: "7rem" }} />

      <div style={{ fontWeight: 700, fontSize: "2.5rem", color: "#5D5D5D" }}>
        ไม่พบแพ็กเกจ/รายการตรวจ
      </div>

      <div className="appointment-message-box">
        <div className="appointment-phone-icon-bg">
          <Image src={IMAGES.iconPhoneHeart} className="appointment-phone-icon" />
        </div>
        <div style={{ flex: 1, textAlign: "center" }}>
          <div style={{ color: "rgba(168, 91, 111, 1)", fontSize: "2rem" }}>
            เลือกซื้อแพ็กเกจ/รายการตรวจ
          </div>
          <div style={{ fontSize: "2rem", marginTop: "3rem" }}>
            เพื่อ{" "}
            <span
              style={{
                fontWeight: 700,
                color: "rgba(229, 67, 110, 1)",
                textDecoration: "underline",
              }}
            >
              ยืนยันรับบริการ
            </span>{" "}
            บนมือถือ
          </div>
        </div>
      </div>
    </div>
  </CheckInLayout>
);

NoAppNoPKFound.displayName = "NoAppNoPKFound";

export default NoAppNoPKFound;
